import React from 'react';
import { MuiAccordion, MuiAccordionSummary, MuiAccordionDetails } from './MuiAccordion';
import { useStyles } from './use-styles';
import { Typography } from '@mui/material';
import RebookEditSegments from '../RebookEditSegments';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as TFF from '@tff/types/TFF';
import { useIntl } from 'react-intl';

interface props {
  orderDetails: TFF.OrderDetails;
  journey: TFF.Journey;
  airports: TFF.Airport[];
  retrieveDb?: TFF.Retrieve;
  setEnableSearchAlternatives: (value: boolean) => void;
  setLowerClassForNDC?: (value: boolean) => void;
  setSelectedCabinClassForNDC?: (value: string) => void;
  selectedCabinClassForNDC?: string;
}
//setLowerClassForNdc - NDC only prop
const FlightDetails: React.FC<props> = ({
  orderDetails,
  journey,
  airports,
  retrieveDb,
  setLowerClassForNDC,
  setSelectedCabinClassForNDC,
  selectedCabinClassForNDC,
}) => {
  const classes = useStyles();
  const isNotExpired = (dateString: string): boolean => {
    const givenDate = new Date(dateString);
    const currentDate = new Date();
    return currentDate > givenDate;
  };
  const intl = useIntl();

  return (
    <div className={classes.flightDetailRoot}>
      <MuiAccordion>
        <MuiAccordionSummary
          expandIcon={<ExpandMoreIcon color="primary" />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          disabled={isNotExpired(journey.Segments[0].DepartureTime)}
        >
          <Typography component={'span'} className={classes.heading} style={{ fontSize: '18px' }}>
            {intl.formatMessage({ id: 'rebook.editFlight' })}
          </Typography>
        </MuiAccordionSummary>
        <MuiAccordionDetails>
          <RebookEditSegments
            orderDetails={orderDetails}
            journey={journey}
            airports={airports}
            retrieveDb={retrieveDb}
            setLowerClassForNDC={setLowerClassForNDC}
            setSelectedCabinClassForNDC={setSelectedCabinClassForNDC}
            selectedCabinClassForNDC={selectedCabinClassForNDC}
          />
        </MuiAccordionDetails>
      </MuiAccordion>
    </div>
  );
};

export default FlightDetails;
